import { render, staticRenderFns } from "./sign-gift.vue?vue&type=template&id=c0f844a8&"
import script from "./sign-gift.vue?vue&type=script&lang=js&"
export * from "./sign-gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports